__turbopack_export_value__({
  "body-logo-18": "PaginationArrow-module-scss-module__dh4Kpa__body-logo-18",
  "body-text-12": "PaginationArrow-module-scss-module__dh4Kpa__body-text-12",
  "body-text-14": "PaginationArrow-module-scss-module__dh4Kpa__body-text-14",
  "body-text-16": "PaginationArrow-module-scss-module__dh4Kpa__body-text-16",
  "body-text-18": "PaginationArrow-module-scss-module__dh4Kpa__body-text-18",
  "body-text-20": "PaginationArrow-module-scss-module__dh4Kpa__body-text-20",
  "body-text-24": "PaginationArrow-module-scss-module__dh4Kpa__body-text-24",
  "body-text-24-2": "PaginationArrow-module-scss-module__dh4Kpa__body-text-24-2",
  "body-text-heading-2": "PaginationArrow-module-scss-module__dh4Kpa__body-text-heading-2",
  "body-text-heading-3": "PaginationArrow-module-scss-module__dh4Kpa__body-text-heading-3",
  "body-text-medium-14": "PaginationArrow-module-scss-module__dh4Kpa__body-text-medium-14",
  "body-text-medium-16": "PaginationArrow-module-scss-module__dh4Kpa__body-text-medium-16",
  "body-text-medium-18": "PaginationArrow-module-scss-module__dh4Kpa__body-text-medium-18",
  "body-text-medium2-18": "PaginationArrow-module-scss-module__dh4Kpa__body-text-medium2-18",
  "body-text2-14": "PaginationArrow-module-scss-module__dh4Kpa__body-text2-14",
  "body-text2-16": "PaginationArrow-module-scss-module__dh4Kpa__body-text2-16",
  "button": "PaginationArrow-module-scss-module__dh4Kpa__button",
  "button-primary-text": "PaginationArrow-module-scss-module__dh4Kpa__button-primary-text",
  "button-text": "PaginationArrow-module-scss-module__dh4Kpa__button-text",
  "button2-text": "PaginationArrow-module-scss-module__dh4Kpa__button2-text",
  "button_disabled": "PaginationArrow-module-scss-module__dh4Kpa__button_disabled",
  "button_reversed": "PaginationArrow-module-scss-module__dh4Kpa__button_reversed",
  "card-shadow": "PaginationArrow-module-scss-module__dh4Kpa__card-shadow",
  "effect-menu": "PaginationArrow-module-scss-module__dh4Kpa__effect-menu",
  "header-1": "PaginationArrow-module-scss-module__dh4Kpa__header-1",
  "main-container": "PaginationArrow-module-scss-module__dh4Kpa__main-container",
  "main-footer-container": "PaginationArrow-module-scss-module__dh4Kpa__main-footer-container",
  "main-header-container": "PaginationArrow-module-scss-module__dh4Kpa__main-header-container",
  "txt-12-bold": "PaginationArrow-module-scss-module__dh4Kpa__txt-12-bold",
  "txt-14-bold": "PaginationArrow-module-scss-module__dh4Kpa__txt-14-bold",
  "txt-14-bold-caps": "PaginationArrow-module-scss-module__dh4Kpa__txt-14-bold-caps",
  "txt-14-med": "PaginationArrow-module-scss-module__dh4Kpa__txt-14-med",
  "txt-16-bold": "PaginationArrow-module-scss-module__dh4Kpa__txt-16-bold",
  "txt-16-med": "PaginationArrow-module-scss-module__dh4Kpa__txt-16-med",
  "txt-18-bold": "PaginationArrow-module-scss-module__dh4Kpa__txt-18-bold",
  "txt-18-medium": "PaginationArrow-module-scss-module__dh4Kpa__txt-18-medium",
  "txt-18-medium-24": "PaginationArrow-module-scss-module__dh4Kpa__txt-18-medium-24",
  "txt-24-semi": "PaginationArrow-module-scss-module__dh4Kpa__txt-24-semi",
});
